import axios from "axios";
import { saveAs } from "file-saver";
import { PROYECT } from "services/api";
import { getErrorBlob } from "helpers/extractError";
import { setSnackbar, startRequestComp, stopRequestComp } from "redux/actions/search/searchActions";
import { reportDayTypes } from "redux/reducers/Reports/reportDay/types";

const { SET_REPORT_DAY_FILTERS } = reportDayTypes;

export const getReportDaysAction = ({ date, station, isPdf = true }) => {
  return async (dispatch, getState) => {
    const token = getState().login.token || localStorage.getItem('crm-user');
    const auth = { headers: { authorization: token } };
    const reportUrl = `${process.env.REACT_APP_URL}${PROYECT}/day-report/stations/${station.id}?date=${date}&pdf=${isPdf}`;
    const fileName = `ReporteDia_${station.name}_${date}.${isPdf ? `pdf` : `xlsx`}`;

    dispatch(startRequestComp('loadingReportDay'));
    const access = {
      url: reportUrl,
      method: 'GET',
      responseType: 'blob',
      ...auth,
    };
    try {
      const pdf = await axios(access);
      saveAs(pdf.data, fileName);
      dispatch(setSnackbar(`${isPdf ? `PDF` : 'Excel'} Descargado con éxito`, "success"));
    } catch (err) {
      dispatch(setSnackbar(await getErrorBlob(err)));
    } finally {
      dispatch(stopRequestComp('loadingReportDay'));
    }
  };
};

export const setReportDayFilters = (key = "", value) => {
  return {
    type: SET_REPORT_DAY_FILTERS,
    payload: { value, key },
  };
};
